import Typography from "@mui/material/Typography";
import {Alert, Box, Button, Checkbox, Divider, FormControlLabel, Stack, TextField, useTheme} from "@mui/material";
import {useContext, useState} from "react";
import OrderContext from "../../../context/OrderContext";
import {formatHuman, thousandSeparator} from "../../../utils/utils";
import TourOfficeContext from "../../../context/TourOfficeContext";
import {useTranslation} from "react-i18next";
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import termsPdf from '../../../assets/ASZF-2026-10-01.pdf';

const Summary = () => {
    const {getComment, setComment, displayDeliveryAddress, displayReturnAddress, applyDiscount, calculatePrice, getDiscount, getDeliveryAddress, getReturnAddress, getStartDate, getEndDate, getOrderRx, getOrderTx, getTourOffice, placeOrder, getUsageCountry, isUrgentOrder, calculateUrgencyFee} = useContext(OrderContext)
    const {findTourOffice} = useContext(TourOfficeContext)
    const {t} = useTranslation()
    const [termsAccepted, setTermsAccepted] = useState(false)

    const theme = useTheme()
    return <Box className="white-card">
        <Typography variant="headline4">{t('new_order.summary')}</Typography>
        <Stack spacing={2} marginTop={2} marginBottom={1}>
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant='caption' color={theme.palette.primary[500]}>{t('new_order.delivery_address')}</Typography>
                <Typography variant='body1'>{(getDeliveryAddress()?.address && displayDeliveryAddress()) || 'Tourguide iroda'}</Typography>
            </Stack>
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant='caption' color={theme.palette.primary[500]}>{t('new_order.return_address')}</Typography>
                <Typography variant='body1'>{(getReturnAddress()?.address && displayReturnAddress()) || 'Tourguide iroda'}</Typography>
            </Stack>
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant='caption' color={theme.palette.primary[500]}>{t('new_order.order_dates')}</Typography>
                <Typography variant='body1'>{getStartDate() ? formatHuman(getStartDate()) : '-'} - {getEndDate() ? formatHuman(getEndDate()) : '-'}</Typography>
            </Stack>
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant='caption' color={theme.palette.primary[500]}>{t('new_order.ordered_devices')}</Typography>
                <Typography variant='body1'>{t('new_order.receiver')}: {getOrderRx()} | {t('new_order.transmitter')}: {getOrderTx()} {t('new_order.plus_reserve')}</Typography>
            </Stack>
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant='caption' color={theme.palette.primary[500]}>{t('orders.usage_country')}</Typography>
                <Typography variant='body1'>{getUsageCountry() || '-'}</Typography>
            </Stack>
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant='caption' color={theme.palette.primary[500]}>{t('new_order.invoice_data')}</Typography>
                <Typography variant='body1'>{findTourOffice(getTourOffice())?.name}</Typography>
            </Stack>
            {isUrgentOrder() && <Stack direction='row' justifyContent='space-between'>
                <Typography variant='caption' color={theme.palette.primary[500]}>{t('new_order.urgent_fee')}</Typography>
                <Typography variant='body1'>+{thousandSeparator(Math.round(calculateUrgencyFee()))} Ft</Typography>
            </Stack>}
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant='caption' color={theme.palette.primary[500]}>{t('general.price')}</Typography>
                {getDiscount() ? <Stack direction='row' spacing={1}><Typography variant='body1Overline'>{thousandSeparator(calculatePrice())} Ft</Typography><Typography variant='body1'>{thousandSeparator(applyDiscount(calculatePrice()))} Ft</Typography></Stack> : <Typography variant='body1'>{thousandSeparator(calculatePrice())} Ft</Typography>}
            </Stack>
            {isUrgentOrder() && <Alert severity='warning'>{t('new_order.urgent_fee_summary_warning')}</Alert>}
            <Stack spacing={2}>
                <Typography variant='caption' color={theme.palette.primary[500]}>{t('general.comment')}</Typography>
                <TextField placeholder={t('general.comment_description')} variant='standard' multiline rows={3} value={getComment()} onChange={e => setComment(e.target.value)}/>
            </Stack>
            <Typography variant='body2'>{t('new_order.comment')}</Typography>
        </Stack>
        <Divider/>

        <Stack marginTop={2} spacing={2}>
            <FormControlLabel
                control={<Checkbox checked={termsAccepted} onChange={e => setTermsAccepted(e.target.checked)}/>}
                label={<Typography variant='body2'>{t('new_order.accept_terms')} <a target='_blank' rel="noreferrer" href={termsPdf}>{t('new_order.terms_and_conditions')}</a></Typography>}
            />
            <Button endIcon={<ArrowUpwardRoundedIcon/>} variant='outlined' disabled={!termsAccepted} onClick={() => placeOrder()}>{t('new_order.submit')}</Button>
        </Stack>

    </Box>
}

export default Summary